import { Component, OnInit } from '@angular/core';
import { CommonServices } from 'src/app/Common/CommonServices';
import { PlatformChargesClient, WebinarClient, WebinarSettlementDetailsForAllDto, WebinarSettlementDetailsGetDTO } from 'src/app/Services/WOWApi.Service';
import { CreateSettlementComponent } from '../create-settlement/create-settlement.component';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/Services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-webinar-settlement',
    templateUrl: './webinar-settlement.component.html',
    styleUrls: ['./webinar-settlement.component.css'],
    standalone: false
})
export class WebinarSettlementComponent implements OnInit {
  details: WebinarSettlementDetailsForAllDto[] = [];
  toBeSettledDetails: WebinarSettlementDetailsGetDTO[] = [];
  roomOnwerId: number = 0;
  pendingForSettlement = 0; // amount which is pending for webinar to be closed
  readyForSettlement = 0; // all closed webinars included in this
  isMobileView = false;
  subscription: Subscription;
  searchValue: number | null = null;
  includeUnsoldSeats = false;
  includePendingShipping = false;
  constructor(
    private platformChargesClient: PlatformChargesClient,
    private commonServices: CommonServices,
    private dialog: MatDialog,
    private commonService: CommonService,
    private webinarClient: WebinarClient
  ) {}

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.getWebinarSettlementsForAllRooms();
  }
  
  getWebinarSettlementsForAllRooms() {
    this.commonService.setSpinner(true);
    this.webinarClient.getRoomWiseAccountSettlementDetailsForAllRooms(
      this.includeUnsoldSeats,
      this.includePendingShipping
    ).subscribe({
      next: (res) => {
        this.details = res;
        this.commonService.setSpinner(false);
      },
      error: (error) => {
        this.commonService.setSpinner(false);
        this.commonServices.showMessage('error', error, 4);
      }
    });
  }

  onFilterChange() {
    this.toBeSettledDetails = [];
    this.roomOnwerId = 0;
    this.getWebinarSettlementsForAllRooms();
  }

  onIncludeUnsoldSeatsChange(checked: boolean) {
    this.includeUnsoldSeats = checked;
    this.onFilterChange();
  }

  onIncludePendingShippingChange(checked: boolean) {
    this.includePendingShipping = checked;
    this.onFilterChange();
  }
  onSearch(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    this.searchValue = input ? parseFloat(input) : null;
  }

  getFilteredDetails(detail: WebinarSettlementDetailsForAllDto): WebinarSettlementDetailsGetDTO[] {
    if (!detail.details) {
      return [];
    }
    if (this.searchValue == null) {
      return detail.details;
    }
    return detail.details.filter(d =>
      d.pendingForSettlement === this.searchValue ||
      d.settledAmount === this.searchValue ||
      d.readyForSettlement === this.searchValue ||
      d.toBeSettledAmountAfterPlatformChargesDeduction === this.searchValue
    );
  }

  hasVisibleRooms(): boolean {
    return this.details.some(detail => this.getFilteredDetails(detail).length > 0);
  }

  isSelected(settlement: WebinarSettlementDetailsGetDTO): boolean {
    return this.toBeSettledDetails.some(x => x.webinarId === settlement.webinarId);
  }

  getSelectedTotal(): number {
    return this.toBeSettledDetails.reduce(
      (sum, x) => sum + x.toBeSettledAmountAfterPlatformChargesDeduction, 0
    );
  }

  getWebinarStatusClass(status?: string): string {
    const normalized = (status || '').toLowerCase().replace(/\s+/g, '-');
    if (normalized.includes('complete')) {
      return 'status-completed';
    }
    if (normalized.includes('close')) {
      return 'status-closed';
    }
    if (normalized.includes('open') || normalized.includes('run')) {
      return 'status-open';
    }
    if (normalized.includes('schedule') || normalized.includes('pending')) {
      return 'status-scheduled';
    }
    return 'status-default';
  }

  onChangeSelection(event: MatCheckboxChange, settlement: WebinarSettlementDetailsGetDTO, roomOwnerId: number) {
    if (this.roomOnwerId !== 0 && roomOwnerId !== this.roomOnwerId && event.checked === true) {
      this.commonServices.showMessage('error', 'Webinar room can not be changed, remove other romm webinar if you want to proceed with this.');
      event.source.checked = false;
      return;
    }
    if (this.toBeSettledDetails.some(x => x.roomId !== settlement.roomId) && event.checked === true) {
      this.commonServices.showMessage('error', 'Webinar room can not be changed, remove other romm webinar if you want to proceed with this.');
      event.source.checked = false;
      return;
    }
    if (event.checked === true) {
      this.toBeSettledDetails.push(settlement);
      this.roomOnwerId = roomOwnerId;
    } else {
      const idx = this.toBeSettledDetails.findIndex(x => x.webinarId === settlement.webinarId);
      if (idx >= 0) {
        this.toBeSettledDetails = this.toBeSettledDetails.filter(x => x.webinarId !== settlement.webinarId);
      }
    }
    if (this.toBeSettledDetails.length === 0) {
      this.roomOnwerId = 0;
    }
  }

  onSettleWebinar() {
    this.dialog.open(CreateSettlementComponent, {
      width: 'calc(auto - 90px)',
      height: 'calc(auto - 90px)',
      data: {
        settlements: this.toBeSettledDetails,
        isNewSettlement: true,
        roomOwnerId: this.roomOnwerId
      }
    })
  }

  onChangeAccordion() {
    this.toBeSettledDetails = [];
    let ele = document.getElementById('checkboxSettlement') as HTMLInputElement;
    console.log(ele);
    ele.checked = false;
  }

}
